import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import arrow from "../../Images/arrow2.png";
import finalLogo from "../../Images/Production_logo.PNG";
import Hamburger from "../Hamburger/Hamburger";
import "./Bnav.css";
function Bnav() {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    // console.log("executed", showNavbar);
    setShowNavbar(!showNavbar);
  };

  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/", { replace: true });
  };

  const onClickHandle = () => {
    navigate("/booking", { replace: true });
  };

  const onClickContactHandle = () => {
    navigate("/contact", { replace: true });
  };

  const handleOnGalleryClick = () => {
    navigate("/gallery", { replace: true });
  };

  const handleAnywhereClick = () => {
    if (window.innerWidth <= 600) {
      if (showNavbar) setShowNavbar(!showNavbar);
    }
  };

  return (
    <div className="bnavbar" onClick={handleAnywhereClick}>
      <div className="bnav">
        <div className="b-left">
          <img
            src={finalLogo}
            alt="four seasons resort, jamshedpur"
            className="logo-image-size"
          />
        </div>
        <div className="menu-icon" onClick={handleShowNavbar}>
          <Hamburger />
        </div>
        <div className={`b-right ${showNavbar && "active"}`}>
          <ul className="b-list">
            <li onClick={handleClick} className="b-r-list">
              Home
            </li>
            <li
              onClick={onClickHandle}
              className="b-r-list"
              id="b-r-list-booking"
            >
              Booking
            </li>
            <li className="b-r-list" onClick={handleOnGalleryClick}>
              Gallery
            </li>
            <li onClick={onClickContactHandle} className="b-r-list">
              Contact
            </li>
          </ul>
        </div>
      </div>
      <div className="b-hero">
        <h1 className="b-hero-title">
          Elegant<br></br>Bedrooms
        </h1>
        <p className="b-hero-discription">
          Embrace the coziness of our bedrooms, where modern comforts blend
          seamlessly with natural beauty
        </p>
        <button className="b-btn">
          <p className="b-btn-text">Explore Rooms</p>{" "}
          <img src={arrow} alt="arrow" className="b-img" />
        </button>
      </div>
    </div>
  );
}

export default Bnav;
